import { atom } from 'jotai';

import { Activity, ActivitySwing } from '@data';

import { currentUserIdAtom } from '../global/user';
import { userSettingsAtom } from '../user/user';

export const activityAtom = atom<Activity | undefined>();

export const activitySwingsAtom = atom<ActivitySwing[] | undefined>();

export const activityUserIdAtom = atom((get) => {
    const data = get(activityAtom);
    return data?.userId;
});

export const activeUserIdAtom = atom((get) => get(activityUserIdAtom) || get(currentUserIdAtom));

export const studentIdAtom = atom((get) => {
    const activityUserId = get(activityUserIdAtom);
    const currentUserId = get(currentUserIdAtom);
    return activityUserId !== currentUserId ? activityUserId : undefined;
});

export const isActiveCurrentUserAtom = atom((get) => get(currentUserIdAtom) === get(activityUserIdAtom));

export const activityUnitAtom = atom((get) => get(userSettingsAtom).userPreferredUnit);
